import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

export default function DeadlineSet({ events }) {
  const { t } = useTranslation();
  const ideaStr = util.pluralise(
    events.length,
    t("generic.idea"),
    t("generic.ideas"),
    false,
  );
  return (
    <Trans
      i18nKey="notifications.ideaDeadlineSet"
      values={{ ideaStr, ideas: util.getEventNames(events, "ownerIdea") }}
      components={{ b: <b /> }}
    />
  );
}
